import "./SystemMessagesComponent.scss";
import template from "./SystemMessagesComponent.html";
import {IComponentOptions} from "angular";
import {SystemAlertStore} from "../../alerts/store/SystemAlertStore";
import {SystemPromptStore} from "../../prompts/store/SystemPromptStore";
import {Observable} from "rxjs";
import {SystemAlert} from "../../alerts/model/SystemAlert";
import {SystemPrompt} from "../../prompts/model/SystemPrompt";
import {isNotNull} from "../../../../js/util/UtilFunctions";

export const SystemMessageBar = "tfSystemMessagesBar";

export function systemMessageBar(): IComponentOptions {
    return {
        template,
        controller: SystemMessagesComponentController,
        controllerAs: "ctrl"
    };
}

export class SystemMessagesComponentController {

    public readonly alert: Observable<SystemAlert | null>;
    public readonly showAlert: Observable<boolean>;
    public readonly prompt: Observable<SystemPrompt | null>;
    public readonly showPrompt: Observable<boolean>;

    /** @ngInject */
    public constructor(private readonly systemAlertStore: SystemAlertStore,
                       private readonly systemPromptStore: SystemPromptStore) {
        this.alert = this.systemAlertStore.current;
        this.showAlert = this.alert.map(isNotNull).startWith(false);
        this.prompt = this.systemPromptStore.current;
        this.showPrompt = this.prompt.map(isNotNull).startWith(false);
    }
}
